import { sundayGapContent } from "./sundayGapContent"

const headingClass =
  "text-balance text-[40px] font-bold leading-[48px] tracking-[-0.04em] text-[#171717] max-md:text-[28px] max-md:leading-8"

export default function SundayGapSection() {
  return (
    <section className="flex w-full translate-x-[calc(50vw-50%-1.5rem)] flex-col gap-8">
      <div className="flex flex-col gap-3">
        <p className="text-[14px] font-medium leading-5 text-[#4D4D4D]">{sundayGapContent.eyebrow}</p>
        <h2 className={headingClass}>{sundayGapContent.title}</h2>
      </div>
      <div className="flex max-w-[68ch] flex-col gap-6">
        <p className="text-[18px] font-normal leading-7 text-[#4D4D4D]">{sundayGapContent.lead}</p>
        <p className="text-[18px] font-normal leading-7 text-[#4D4D4D]">{sundayGapContent.body}</p>
      </div>
    </section>
  )
}
